<template>
  <div class="customer-list-wrapper p-2">
    <div class="row">
      <div class="col-md-4">
        <h4 class="mt-10">Customer Plan Audit</h4>
      </div>
      <div class="col-md-8">
        <button
          class="nav-link btn btn-outline-default btn-round btn-default refresh-user-link"
          v-on:click="refreshHostingAccountList"
        >
          <i class="fa fa-refresh"></i> Refresh hosting account list
        </button>
      </div>
    </div>

    <div class="customer-list-info" v-if="loading">
      <div class="loader"></div>
      <p
        class="card-text text-center text-danger mb-3 font-weight-bold"
        v-if="noUser && !loading"
      >
        There are no user in the database to show here. Please create some users
        in order for them to show up here.
      </p>
    </div>
    <div class="customer-table pt-20" v-if="!loading">
      <div>
        <p>Total Discrepancy Count: {{ totalDiscrepancyCount }}</p>
        <p>Total Records: {{ totalRecords }}</p>
      </div>

      <div  class="row d-flex justify-content-start align-items-center pb-5">
        <div class="col-md-4">
          <div><label>Search By IP</label></div>
          <input
              v-model="searchQuery"
              type="text"
              class="form-control mt-2"
              placeholder="Search by IP"
          />
        </div>
        <div class="col-md-3">
          <div><label>Search By Plan Name</label></div>
          <select v-model="selectedPlan" class="form-control" >
            <template v-for="(row) in plans">
              <option  :value="row.value">{{ row.key }}</option>
            </template>
          </select>
        </div>
      </div>
      <table
        id="datatable"
        class="table table-striped table-bordered mt-3"
        cellspacing="0"
        width="100%"
      >
        <thead>
          <tr>
            <th>IP</th>
            <th class="text-center">Plan</th>
            <th class="text-center">Plan Limit</th>
            <th class="text-center">Extra Sites</th>
            <th class="text-center">Max Addon Domains</th>
            <th class="text-center">Total Addons</th>
            <th class="text-center">Discrepency</th>
            <th class="text-right">Message</th>
            <th class="disabled-sorting text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(hostingAccountRecord, index) in paginatedAccounts"
            :key="index"
          >
            <td class="text-start">
              {{ hostingAccountRecord.primary.serverIP }}
            </td>
            <td class="text-center">{{ hostingAccountRecord.planName }}</td>
            <td class="text-center">
              <div v-if="editIndex != index">
                {{ hostingAccountRecord.planLimit }}
              </div>
              <div v-else-if="editIndex > -1 && editIndex == index">
                <input
                  type="number"
                  class="form-control"
                  v-model.number="planLimit"
                />
              </div>
            </td>
            <td class="text-center">
              <div v-if="editIndex != index">
                {{ hostingAccountRecord.extraDomains }}
              </div>
              <div v-else-if="editIndex > -1 && editIndex == index">
                <input
                  type="number"
                  class="form-control"
                  v-model.number="extraDomains"
                />
              </div>
            </td>
            <td class="text-center">
              {{ hostingAccountRecord.maxAddonDomain }}
            </td>
            <td class="text-center">{{ hostingAccountRecord.addon.length }}</td>
            <td
              class="text-center"
              :style="{ color: hostingAccountRecord.discrepancy ? 'red' : '' }"
            >
              {{ hostingAccountRecord.discrepancy }}
            </td>
            <td class="text-center">{{hostingAccountRecord.messages.toString()}}</td>
            <td class="text-center">
              <button
                tag="a"
                class="btn text-light btn-link bg-default btn-sm edit mr-2 pull-left"
                v-if="editIndex > -1"
                :disabled="editIndex != index"
                :loading="saveLoading"
                @click="save(hostingAccountRecord)"
              >
                <i class="fa fa-save"></i>
              </button>
              <button
                tag="a"
                class="btn text-light btn-link bg-default btn-sm edit mr-2 pull-left"
                v-if="editIndex == -1"
                @click="changeLimits(index, hostingAccountRecord)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                tag="a"
                class="btn text-light btn-link bg-default btn-sm edit mr-2 pull-left"
                v-if="editIndex > -1"
                :disabled="editIndex != index"
                @click="close()"
              >
                <i class="fa fa-times"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="row mt-2">
        <div class="col-md-12 text-center">
          <span class="pull-left mt-2"
            ><b>Page Number: </b> {{ currentPage }}</span
          >
          <button
            class="btn btn-link btn-sm btn-round"
            :disabled="currentPage === 1"
            v-on:click="changePage('prev')"
          >
            Prev
          </button>
          <button
            class="btn btn-link btn-sm btn-round"
            :disabled="paginatedAccounts.length < pageSize"
            v-on:click="changePage('next')"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebase/init";
import { color } from "d3";

export default {
  name: "customerAuditList",
  data() {
    return {
      searchBy: null,
      noUser: false,
      asyncDone: true,
      searchQuery: "",
      loading: false,
      records: [],
      currentPage: 1,
      pageSize: 1000,
      totalDiscrepancyCount: 0,
      totalRecords: 0,
      editIndex: -1,
      planLimit: 0,
      extraDomains: 0,
      saveLoading: false,
      selectedPlan: '',
      plans: [
        { key: 'Select Plan', value: '' },
        { key: 'WPO Enterprise', value: 'WPO Enterprise' },
        { key: 'WPO VPS', value: 'WPO VPS' },
        { key: 'WPO Starter', value: 'WPO Starter' },
        { key: 'WPO Professional', value: 'WPO Professional' },
        { key: 'WPO Business', value: 'WPO Business' },
      ]
    };
  },
  computed: {
      paginatedAccounts() {
        let filteredPlans = this.records.filter((value) => {
          const matchesPlan = !this.selectedPlan || value.planName === this.selectedPlan;
          const matchesIP = !this.searchQuery || (value.primary.serverIP && value.primary.serverIP.includes(this.searchQuery));
          return matchesPlan && matchesIP;
        });

        // Pagination logic: calculate start and end based on the current page and page size
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;

        // Sort filtered records by discrepancy, and then slice for pagination
        return filteredPlans
            .sort((a, b) => b.discrepancy - a.discrepancy)
            .slice(start, end);
      },
  },
  mounted() {
    this.fetchHostingAccounts();
  },
  methods: {
    refreshUsers() {},
    changeLimits(index, item) {
      console.log("customer audit", index, item);
      this.editIndex = index;
      this.planLimit = item.planLimit;
      this.extraDomains = item.extraDomains;
    },
    close() {
      this.editIndex = -1;
      this.planLimit = 0;
      this.extraDomains = 0;
    },
    async save(item) {
      try {
        this.saveLoading = true
        const hostingAccountSnapshot = await db
          .collection("hostingAccounts")
          .doc(item.id)
          .get();

        if (!hostingAccountSnapshot.exists) {
          console.log(`No hosting account found for user_id: ${item.id}`);
        } else {
          const { accounts } = hostingAccountSnapshot.data();

          // Find account where `server_ip` matches `primary.serverIP`
          const matchingAccountIndex = accounts.findIndex(
            (acc) => acc.primary.serverIP === item.primary.serverIP
          );

          if (matchingAccountIndex !== -1) {
            const matchingAccount = accounts[matchingAccountIndex];

            matchingAccount.planLimit = this.planLimit;
            matchingAccount.extraDomains = this.extraDomains;

            await db
              .collection("hostingAccounts")
              .doc(item.id)
              .update({
                accounts: accounts,
              });
            console.log("Account updated successfully.");
          } else {
            console.log("No matching hosting account found for the server IP");
          }
        }
        this.refreshHostingAccountList()
      } catch (error) {
        console.error("Error updating hosting account:", error);
      }finally {
        this.saveLoading = false
        this.close()
      }
    },
    async fetchHostingAccounts() {
      try {
        this.loading = true;
        const { data } = await this.$http.get("alerts/fetchRecords");
        this.records = data.records;
        this.totalDiscrepancyCount = data.records.filter(
          (record) => record.discrepancy === true
        ).length;
        this.totalRecords = data.records.length;
        console.log("length", data.records.length);
        this.loading = false;
      } catch (e) {
        console.log(e.toString(), "Could not fetch hosting account list");
      }finally {
        this.loading = false;
      }
    },
    async refreshHostingAccountList() {
      try {
        this.loading = true;
        await this.$http.get("alerts/updateRecordsInRedis");
        await this.fetchHostingAccounts();
        this.loading = false;
      } catch (error) {
        console.log(e.toString(), "Could not update hosting account list");
      }finally {
        this.loading = false;
      }
    },
    changePage(flag) {
      this.currentPage =
        flag === "next" ? this.currentPage + 1 : this.currentPage - 1;
    },
  },
};
</script>

<style>
.refresh-user-link {
  position: absolute;
  top: 15px;
  right: 15px;
}

.refresh-storage-link {
  position: absolute;
  top: 15px;
  right: 215px;
}

.progress {
  margin-bottom: 10px;
}
</style>
